export default __webpack_public_path__ + "static/media/card_bg.10049e8a.jpg";